"use client";

import type { ReactNode } from "react";
import { I18nProvider } from "@/lib/i18n";
import type { Lang } from "@/lib/i18n";
import { MobileNav } from "./mobile-nav";
import { PwaManager } from "./pwa-manager";
import { Sidebar } from "./sidebar";
import { TopBar } from "./top-bar";
import type { CollectorRun } from "@/lib/types";
import { PocBanner } from "./poc-banner";

export function AppShell({ collectorRun, initialLang, title, kicker, children }: { collectorRun: CollectorRun | null; initialLang: Lang; title: string; kicker: string; children: ReactNode }) {
  return (
    <I18nProvider initialLang={initialLang}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <div data-app-shell className="min-h-dvh bg-[var(--hc-bg)] text-[var(--hc-text)]">
        <PwaManager />
        <div className="flex min-h-dvh">
          <Sidebar />
          <div className="min-w-0 flex-1">
            <TopBar collectorRun={collectorRun} title={title} kicker={kicker} />
            <PocBanner />
            <main id="main-content" tabIndex={-1} className="mx-auto max-w-[1600px] px-4 pb-28 pt-5 md:px-6 md:pt-6 lg:pb-10">{children}</main>
          </div>
        </div>
        <MobileNav />
      </div>
    </I18nProvider>
  );
}
